import { Configuration, FrontendApi } from '@ory/client';
import { APP_ORY_URL } from './constants/urls';

// Get your Ory url from .env
// Or localhost for local development
const basePath = APP_ORY_URL;
export const ory = new FrontendApi(
    new Configuration({
        basePath,
        baseOptions: {
            withCredentials: true
        }
    })
);
